module.exports = __webpack_public_path__ + "img/banner_desktop_dorada.64f075e6.jpg";